import cn from "classnames";
import IMG from "components/Image";
import Checkbox from "components/Input/Checkbox";
import Text from "components/Text";
import { useAppAssetsWithSrc } from "Theme/EVENTS_ASSETS";

const SelectGuest = ({
  onChange,
  imageSrc,
  inputId,
  checked,
  inputName,
  first_name,
  last_name,
  isDisabled = false,
  className = "",
  inputClassName = "",
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  imageSrc?: string;
  inputId: string;
  checked?: boolean;
  inputName?: string;
  first_name: string;
  last_name: string;
  isDisabled?: boolean;
  className?: string;
  inputClassName?: string;
}) => {
  const EVENT_ASSETS = useAppAssetsWithSrc();

  return (
    <label
      htmlFor={inputId}
      className={cn(
        "flex p-5 items-center gap-x-6 cursor-pointer -bg--component-colors-gd-option-selection-card-selected-bg -rounded-user-card",
        {
          "border -border--component-colors-gd-option-selection-card-selected-border":
            !!checked,
          "pointer-events-none opacity-50": isDisabled,
        },
        className,
      )}
    >
      <Checkbox
        type="checkbox"
        checked={checked}
        onChange={onChange}
        id={inputId}
        name={inputName}
        disabled={isDisabled}
        className={cn("px-0 py-0", inputClassName)}
      />

      <IMG
        src={imageSrc || EVENT_ASSETS.eventPlaceholder.src}
        fallbackSrc={EVENT_ASSETS.eventPlaceholder.fallbackSrc}
        alt="--"
        className="h-9 w-9 object-cover rounded-full"
      />

      <Text
        as="strong"
        className="capitalize -text--component-colors-gd-option-selection-card-selected-high"
      >
        {first_name} {last_name}
      </Text>
    </label>
  );
};

export default SelectGuest;
